/** Web App Studio (WP-M29-WEBAPP-STUDIO): mirror of backend `app/core/constants/webapp_studio.py`.
 *  `backend/tests/core/test_webapp_studio_mirror.py` keeps every export equal to its backend twin. */

export const WEBAPP_THEME_VALUES = ["system", "light", "dark"] as const;
export type WebappTheme = (typeof WEBAPP_THEME_VALUES)[number];

export const WEBAPP_DENSITY_VALUES = ["comfortable", "compact"] as const;
export type WebappDensity = (typeof WEBAPP_DENSITY_VALUES)[number];

export const WEBAPP_AVATAR_SOURCE_VALUES = ["widget", "custom", "initials"] as const;
export type WebappAvatarSource = (typeof WEBAPP_AVATAR_SOURCE_VALUES)[number];

export const WEBAPP_SEND_STYLE_VALUES = ["icon", "label"] as const;
export type WebappSendStyle = (typeof WEBAPP_SEND_STYLE_VALUES)[number];

export const WEBAPP_POWERED_BY_VALUES = ["widget", "show", "hide"] as const;
export type WebappPoweredBy = (typeof WEBAPP_POWERED_BY_VALUES)[number];

export const WEBAPP_SCOPE_VALUES = ["assistant", "default"] as const;
export type WebappScope = (typeof WEBAPP_SCOPE_VALUES)[number];

export const WEBAPP_SOURCE_VALUES = ["assistant", "default", "widget"] as const;
export type WebappSource = (typeof WEBAPP_SOURCE_VALUES)[number];

export const WEBAPP_ASSISTANT_ICON_AVATAR = "avatar" as const;
export const WEBAPP_CARD_ICON_AUTO = "auto" as const;
export const WEBAPP_CARD_ICON_NONE = "none" as const;

export const WEBAPP_ICON_VALUES = [
  "bot",
  "sparkles",
  "graduation-cap",
  "headset",
  "message-circle",
  "life-buoy",
  "book-open",
  "brain",
  "heart",
  "star",
  "zap",
  "building-2",
  "help-circle",
  "file-text",
  "wallet",
  "calendar",
  "map-pin",
  "list-checks",
] as const;
export type WebappIconName = (typeof WEBAPP_ICON_VALUES)[number];

export const WEBAPP_MAX_STARTERS = 6 as const;
export const WEBAPP_STARTER_MAX_CHARS = 120 as const;
export const WEBAPP_APP_NAME_MAX_CHARS = 60 as const;
export const WEBAPP_TITLE_MAX_CHARS = 60 as const;
export const WEBAPP_LINE_MAX_CHARS = 160 as const;
export const WEBAPP_PLACEHOLDER_MAX_CHARS = 80 as const;
export const WEBAPP_NOTE_MAX_CHARS = 240 as const;

export const WEBAPP_SETTINGS_KEY = "webapp_studio" as const;
